'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckboxInput } from '@lichtblick/photon/molecules/legacy-checkbox/checkbox-input';
import { useSearchParams } from 'next/navigation';
import { Textfield } from '../../components/input-with-validation';
import { B2BLegalConsentText, B2BMarketingConsentText } from '../b2b-data-privacy-text';
import styles from './email.module.scss';
import sharedStyles from './shared-styles.module.scss';
export const EmailStep = ({ funnelState })=>{
    const emailError = funnelState?.errors?.email?.email;
    const marketingConsentError = funnelState?.errors?.email?.marketingConsent;
    const webCampaignId = useSearchParams().get('web_campaign_id');
    return /*#__PURE__*/ _jsxs("div", {
        className: sharedStyles['funnel-step'],
        children: [
            /*#__PURE__*/ _jsx(Textfield, {
                defaultValue: funnelState.formValues.email,
                name: "email",
                placeholder: "E-Mail",
                statusLabel: emailError ?? ' ',
                statusType: emailError ? 'error' : 'default',
                type: "email",
                required: true
            }),
            /*#__PURE__*/ _jsx(CheckboxInput, {
                className: styles.checkbox,
                defaultChecked: Boolean(funnelState.formValues.marketingConsent),
                hasError: Boolean(marketingConsentError),
                labelSlot: B2BMarketingConsentText,
                name: "marketingConsent",
                statusLabel: marketingConsentError ?? ' '
            }),
            B2BLegalConsentText,
            webCampaignId && /*#__PURE__*/ _jsx("input", {
                hidden: true,
                name: "webCampaignId",
                readOnly: true,
                value: webCampaignId
            })
        ]
    });
};

//# sourceMappingURL=email.js.map